export function loadScript(src) {

    const isScriptExist = document.querySelector(`#razorpay_checkout`);    

    if (isScriptExist) {
        if (isScriptExist?.src == src) {
            return Promise.resolve(true);
        }
    }

    return new Promise((resolve) => {
        const script = document.createElement('script')
        script.id = "razorpay_checkout";
        script.src = src;

        script.onload = () => {
            script.onload = script.onerror = null;
            resolve(true);
        };

        script.onerror = () => {
            script.onload = script.onerror = null;
            document.body.removeChild(script);
            resolve(false);
        };

        document.body.appendChild(script)

    })

}

